/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WasteAssignment } from '../../models/waste-assignment';
import { WasteAssignmentType } from '../../models/waste-assignment-type';

export interface GetWasteAssignment$Params {
  productionOrderId: number;
  wasteAssignmentType: WasteAssignmentType;
}

export function getWasteAssignment(http: HttpClient, rootUrl: string, params: GetWasteAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WasteAssignment>>> {
  const rb = new RequestBuilder(rootUrl, getWasteAssignment.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.path('wasteAssignmentType', params.wasteAssignmentType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WasteAssignment>>;
    })
  );
}

getWasteAssignment.PATH = '/api/v1/WasteAssignment/{productionOrderId}/{wasteAssignmentType}';
